import { render, staticRenderFns } from "./DetailedBarChart.vue?vue&type=template&id=c9d6e39e&"
import script from "./DetailedBarChart.vue?vue&type=script&lang=js&"
export * from "./DetailedBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports